import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AdminLoginDTO from "../../shared/dtos/adminLoginDTO";
import jwt_decode from "jwt-decode";
import ModelState from "../../shared/states/modelState";

const defaultAdminState: AdminLoginDTO = {
  adminId: 0,
  adminTypeId: 0,
  email: "",
  exp: 0,
  iat: 0,
  name: "",
  phone: "",
  partner: false,
  airportQrAllowed: false,
  qrOptionalAddressAllowed: false,
  guestTripsEnabled: false,
  partnerFee: 0,
  passwordUpdatedAt: null,
  darkMode: false,
};

export const initialState: ModelState<AdminLoginDTO> = {
  value: defaultAdminState,
  status: "idle",
};

export const currentAdminAsync = createAsyncThunk(
  "current/admin/",
  async (token: string) => {
    const verifiedToken: AdminLoginDTO = jwt_decode(token);
    return verifiedToken;
  },
);

export const currentAdminSlice = createSlice({
  name: "currentAdmin",
  initialState,
  reducers: {
    removeCurrentAdminValue: (state) => {
      const currentDarkMode = state.value.darkMode;
      state.value = { ...defaultAdminState, darkMode: currentDarkMode };
    },
    updateAdminPartnerFeeValue: (state, action) => {
      state.value.partnerFee = action.payload;
    },
    updateDarkMode: (state, action) => {
      state.value.darkMode = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(currentAdminAsync.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(currentAdminAsync.fulfilled, (state, action) => {
        state.status = "succeeded";
        const currentDarkMode = state.value.darkMode;
        state.value = { ...action.payload, darkMode: currentDarkMode };
      })
      .addCase(currentAdminAsync.rejected, (state, action) => {
        state.status = "failed";
      });
  },
});

export const {
  removeCurrentAdminValue,
  updateAdminPartnerFeeValue,
  updateDarkMode,
} = currentAdminSlice.actions;

export default currentAdminSlice.reducer;
